var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppointmentDataSelectedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 28,
    viewBox: "0 0 20 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 2H2C0.8954 2 0 2.8954 0 4V26C0 27.1046 0.8954 28 2 28H18C19.1046 28 20 27.1046 20 26V4C20 2.8954 19.1046 2 18 2H15C15 0.8954 14.1046 0 13 0H7C5.8954 0 5 0.8954 5 2ZM8.0638 24.649L10.5572 18H7.0002C6.448 18 6.0002 17.5523 6.0002 17C6.0002 16.4477 6.448 16 7.0002 16H11.9812C11.9939 15.9998 12.0066 15.9998 12.0193 16H12.9809C12.9936 15.9998 13.0064 15.9998 13.0191 16H17.3013C17.8536 16 18.3013 16.4477 18.3013 17C18.3013 17.5523 17.8536 18 17.3013 18H14.4431L16.9365 24.649C17.1304 25.1661 16.8684 25.7425 16.3512 25.9364C15.8341 26.1304 15.2577 25.8684 15.0638 25.3512L13.8054 21.9955H11.1948L9.9365 25.3512C9.7425 25.8684 9.1661 26.1304 8.649 25.9364C8.1319 25.7425 7.8699 25.1661 8.0638 24.649ZM3 9.24H17V7.24H3V9.24ZM8 13.4H3V11.4H8V13.4ZM12.5 15C13.6046 15 14.5 14.1046 14.5 13C14.5 11.8954 13.6046 11 12.5 11C11.3954 11 10.5 11.8954 10.5 13C10.5 14.1046 11.3954 15 12.5 15ZM7 2H13V4H7V2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentDataSelectedIcon);
export default __webpack_public_path__ + "static/media/AppointmentDataSelectedIcon.5306a0cd553f8c734493ebf1ce0f9011.svg";
export { ForwardRef as ReactComponent };